import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string, portionLabel: string = 'Material') =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.Method`]: 'Test Method',
      [`${prefix}.Preparation.ContainsGypsum`]: 'Contains Gypsum',
      [`${prefix}.Preparation.ContainsDissolvedSalt`]: 'Contains Dissolved Salt',
      [`${prefix}.Preparation.SaltContentMeasuredIn`]: 'Salt Content Measured in',
      [`${prefix}.Preparation.SaltContentPpt`]: 'Salt Content',
      [`${prefix}.Preparation.SaltContentGl`]: 'Salt Content',
      [`${prefix}.Preparation.FluidDensity`]: 'Fluid Density',
      [`${prefix}.Preparation.GrainSize`]: 'Grain Size',
      [`${prefix}.Preparation.VisualNominalParticleSize`]: 'Maximum Grain Size Diameter',

      [`${prefix}.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.DryingTray.ContainerMass`]: 'Tare Mass',
      [`${prefix}.DryingTray.WetSoilAndContainerMass`]: `Tare and ${portionLabel} Wet Mass`,
      [`${prefix}.DryingTray.WetSoilMass`]: `${portionLabel} Wet Mass`,
      [`${prefix}.DryingTray.DateTimePlacedInOvenLocal`]: 'Date and Time in Oven',
      [`${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: `Tare and ${portionLabel} Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.DryingTray.ConstantDrySoilMass`]: `${portionLabel} Dry Mass`,

      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.Equipment.Oven`]: 'Oven',
      [`${prefix}.Equipment.DryingTemperature`]: 'Drying Temperature',
      [`${prefix}.Equipment.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.Results.FluidContent`]: 'Fluid Content',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.FluidContent`]: '%',
    })
  );

export default getLabelConfig;
